import { render, staticRenderFns } from "./PrivacyGuidePharming.vue?vue&type=template&id=57007d31&scoped=true"
import script from "./PrivacyGuidePharming.vue?vue&type=script&lang=js"
export * from "./PrivacyGuidePharming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57007d31",
  null
  
)

export default component.exports